import * as tslib_1 from "tslib";
import { Field } from '@swim/recon';
import { DirectiveForm } from './directive-form';
import { LetDirective } from './let-directive';
var LetForm = (function (_super) {
    tslib_1.__extends(LetForm, _super);
    function LetForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LetForm.prototype, "tag", {
        get: function () {
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    LetForm.prototype.cast = function (item) {
        if (item instanceof Field) {
            var key = item.key;
            var rhs = item.value.header('let');
            if (rhs.isDefined()) {
                return new LetDirective(key, rhs);
            }
        }
        return undefined;
    };
    LetForm.Form = new LetForm();
    return LetForm;
}(DirectiveForm));
export { LetForm };
DirectiveForm.addGlobal(LetForm.Form);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGV0LWZvcm0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJsZXQtZm9ybS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFPLEtBQUssRUFBQyxNQUFNLGFBQWEsQ0FBQztBQUN4QyxPQUFPLEVBQUMsYUFBYSxFQUFDLE1BQU0sa0JBQWtCLENBQUM7QUFDL0MsT0FBTyxFQUFDLFlBQVksRUFBQyxNQUFNLGlCQUFpQixDQUFDO0FBRzdDO0lBQTZCLG1DQUEyQjtJQUF4RDs7SUFpQkEsQ0FBQztJQWhCQyxzQkFBSSx3QkFBRzthQUFQO1lBQ0UsTUFBTSxDQUFDLFNBQVMsQ0FBQztRQUNuQixDQUFDOzs7T0FBQTtJQUVELHNCQUFJLEdBQUosVUFBSyxJQUFVO1FBQ2IsRUFBRSxDQUFDLENBQUMsSUFBSSxZQUFZLEtBQUssQ0FBQyxDQUFDLENBQUM7WUFDMUIsSUFBTSxHQUFHLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQztZQUNyQixJQUFNLEdBQUcsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQztZQUNyQyxFQUFFLENBQUMsQ0FBQyxHQUFHLENBQUMsU0FBUyxFQUFFLENBQUMsQ0FBQyxDQUFDO2dCQUNwQixNQUFNLENBQUMsSUFBSSxZQUFZLENBQUMsR0FBRyxFQUFFLEdBQUcsQ0FBQyxDQUFDO1lBQ3BDLENBQUM7UUFDSCxDQUFDO1FBQ0QsTUFBTSxDQUFDLFNBQVMsQ0FBQztJQUNuQixDQUFDO0lBRWUsWUFBSSxHQUFHLElBQUksT0FBTyxFQUFFLENBQUM7SUFDdkMsY0FBQztDQUFBLEFBakJELENBQTZCLGFBQWEsR0FpQnpDO1NBakJZLE9BQU87QUFrQnBCLGFBQWEsQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDIn0=